<template>
  <div class="buy" :class="{'hidePrice':hidePrice}">
    <span class="desc">
      <span class="text">
        开通{{ activeTab === 20 ? '星耀直通卡' : '研力特权卡' }}，仅售<span class="num">{{ priceInfo.price }}</span>
      </span>
      <span v-if="time" class="time">活动倒计时：<common-timer :endTime="time" /> </span>
    </span>
    <span class="del" v-if="!isUpdate && priceInfo.originalPrice">原价{{ priceInfo.originalPrice }}</span>
    <span class="btn" v-if="!isUpdate && isShowBuy" @click="generateOrder(activeTab)"><span class="btn-open">马上开通</span></span>
    <span class="btn" v-if="!isUpdate && !isShowBuy" @click="openChat"><span class="btn-open">联系客服</span></span>
    <span class="btn" v-if="isUpdate" @click="openChat">
      <span class="btn-chat">联系客服</span>
      <span class="btn-desc">计算升级差价</span>
    </span>
  </div>
</template>

<script>
import moment from 'moment';
import CommonTimer from '@/components/commonComponents/CommonTimer.vue';
import {judgmentPlatform} from '@/utils/tools';

export default {
  components: {
    CommonTimer,
  },
  props: {
    activeTab: {
      type: Number,
      default: 20,
    },
    priceInfo: {
      type: Object,
      default: () => ({
        price: '',
        originalPrice: '',
        endTime: '',
      }),
    },
    isUpdate: {
      type: Boolean,
      default: false,
    },
    generateOrder: {
      type: Function,
      default: () => { },
    },
    openChat: {
      type: Function,
      default: () => { },
    },
  },
  data() {
    return {
      time: '',
      isShowBuy: false,
      hidePrice:false
    };
  },
  watch: {
    // eslint-disable-next-line func-names
    'priceInfo.endTime': {
      handler(value) {
        if (value) {
          this.time = moment(value).format('X');
        }
        this.isShowBuy = this.$root.miniprogram === false || this.$root.miniprogramBuyCourse;
      },
      deep: true,
      immediate: true,
    },
  },
  methods:{
    hideIosPrice(){
      this.hidePrice=this.$root.miniprogram&&(judgmentPlatform()==='ios')
    }
  },
  mounted(){
    this.hideIosPrice();
  }
};
</script>

<style scoped lang="scss">
.buy {
  margin-top: 10px;
  width: 750px;
  height: 170px;
  background: #FEFFFE;
  box-shadow: 0px -4 7px 0px rgba(0, 0, 0, 0.05);
  padding: 0 36px 62px;
  display: flex;
  align-items: center;

}
.buy.hidePrice{
  display: none;
}

.desc {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
}

.text {
  font-size: 25px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 40px;
  height: 40px;

  .num {
    font-size: 36px;
    font-family: Arial, Arial;
    font-weight: normal;
    color: #FF3938;
    line-height: 42px;
  }
}

.time {

  font-size: 22px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 31px;
  margin-top: 10px;
}

::v-deep .common-timer {
  display: inline-block;

  .day::after {
    font-size: 22px !important;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #999999 !important;
  }

  b:nth-last-child(1),
  b:nth-last-child(2) {
    margin-left: 10px;

    &::after {
      right: -9px;
      color: rgba(255, 57, 56, 1);
    }
  }

  b:nth-last-child(3) {
    margin-left: 20px;

    &::after {
      right: -9px;
      color: rgba(255, 57, 56, 1);
    }
  }

  b:nth-last-child(4) {
    &::after {
      right: -18px !important;
    }
  }
}

.del {
  font-size: 22px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 31px;
  text-decoration: line-through;
  margin-right: 22px;
}

.btn {
  width: 199px;
  height: 71px;
  background: linear-gradient(270deg, #FF6C02 0%, #FF7F41 100%);
  border-radius: 35px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &-open {
    font-size: 29px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 40px;
  }

  &-chat {
    font-size: 25px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 36px;
  }

  &-desc {
    font-size: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 31px;
  }
}
</style>
